import { IsNotEmpty, IsNumberString, MaxLength, Validate, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { DisplayNameValidation } from 'src/core/customValidator/displayNameValidator';

export class CurrencyDataService extends DataService<typeof Model.General.Logic.ViewModels.CurrencyItem, Model.General.Logic.ViewModels.CurrencyItem, CurrencyItem> {
	protected map(entity: Model.General.Logic.ViewModels.CurrencyItem): CurrencyItem {
		return new CurrencyItemModel(entity);
	}

	public static make(ctx?: any): CurrencyDataService {
		return new CurrencyDataService(ctx, ctx => ctx.Currencies);
	}

	public add(defaultLanguage: string) {
		const entity = new Model.General.Logic.ViewModels.CurrencyItem();
		(entity as any).dynamicProperties['displayName'] = { [defaultLanguage]: '' };
		return entity;
	}
}

export class CurrencyItemModel extends EntityModel<Model.General.Logic.ViewModels.CurrencyItem, CurrencyItem> implements CurrencyItem {

	@property<CurrencyItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(DisplayNameValidation, ['en'])
	public dynamicProperties: {};

	@property<CurrencyItemModel>(o => o.entity.iso3Name, (o, value) => o.entity.iso3Name = value)
	@IsDefined({ message: 'iso3Name is required' })
	@MaxLength(3)
	public iso3Name: string;

	@property<CurrencyItemModel>(o => o.entity.iso3NameCents, (o, value) => o.entity.iso3NameCents = value)
	@MaxLength(10)
	public centsCurrency: string;

	@property<CurrencyItemModel>(o => o.entity.symbol, (o, value) => o.entity.symbol = value)
	@IsDefined({ message: 'symbol is required' })
	@MaxLength(10, { message: 'symbol is to long' })
	public symbol: string;

	@property<CurrencyItemModel>(o => o.entity.decimalPlaces, (o, value) => o.entity.decimalPlaces = value)
	@IsDefined({ message: 'decimalPlaces is required' })
	//@IsNumberString({ message: 'decimalPlaces  must be a number' })
	public decimalPlaces: number;

	@property<CurrencyItemModel>(o => o.entity.format, (o, value) => o.entity.format = value)
	@IsDefined({ message: 'format is required' })
	@MaxLength(15, { message: 'format is to long' })
	public format: string;

	@property<CurrencyItemModel>(o => o.entity.isDefault, (o, value) => o.entity.isDefault = value)
	public isDefault: boolean;
}




// WEBPACK FOOTER //
// ./src/app/general/currencies/form/currency-form.data.ts